/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import { useFormik } from 'formik';

import { useToastErrorMessage } from '@/utils/Messages';

import { Property, PropertyGrouped } from '@/services/Property/types';
import { putReservationStatus } from '@/services/Reservation/request';
import { Reservation } from '@/services/Reservation/types';

import { useLoader } from '@/context/LoaderContext';
import { useReservation } from '@/context/ReservationContext';
import { useToast } from '@/context/ToastContext';

import { useReservationForm } from '@/hooks/ReservationHook/useReservationForm';

import { FormButton, TextField } from '@/components/';
import {
  MediumTextBold,
  TitleContainer,
  Wrapper,
} from '@/components/Calendar/Reservation/ModalGeneral/styles';

import {
  ButtonsContainer,
  Container,
  FadeAnimation,
  FormContainer,
  FormContent,
  Space,
} from './styles';

interface Props {
  props?: object;
  onClose?: Function | boolean | any;
  reservationData?: Reservation | any;
}

const CancellReservation: FC<Props> = ({ onClose }) => {
  const { dataGrouped, setDataGrouped } = useReservationForm();
  const { reservationData, setReservationData } = useReservation();
  const propertyId = reservationData?.listing?.property?.id;
  const toastErrorRequest = useToastErrorMessage();
  const toast = useToast();

  const { setLoad } = useLoader();

  const formik = useFormik({
    initialValues: {
      notes: '',
    },
    onSubmit: async (values) => {
      const newStatus = 'Canceled';
      const id = reservationData?.id;
      const newComment = formik.values.notes;
      const isBlocked = reservationData?.is_blocking;

      setLoad(true);

      try {
        await putReservationStatus(reservationData, newStatus, newComment, id);

        const newReservation = {
          ...reservationData,
          status: newStatus,
          comment: `${reservationData?.comment}; cancellation: ${newComment}`,
        };

        await setReservationData({ ...newReservation });

        const key = newReservation?.check_in_date;

        if (dataGrouped) {
          setDataGrouped(
            dataGrouped.map((category: PropertyGrouped) => ({
              ...category,
              data: category.data.map<Property>((property) => ({
                ...property,
                reservation:
                  property?.id === propertyId
                    ? { ...property.reservation, [key]: { ...newReservation } }
                    : { ...property.reservation },
              })),
            })),
          );
        }
        if (isBlocked === true) {
          toast.success('O bloqueio foi cancelado !');
        } else {
          toast.success('A reserva foi cancelada !');
        }
        setLoad(false);
      } catch (e: unknown) {
        if (e instanceof Error) {
          setLoad(false);
          toastErrorRequest(e);
        }
      }
    },
  });

  return (
    <Container>
      <FormContainer>
        <FormContent onSubmit={formik.handleSubmit}>
          <FadeAnimation>
            <TitleContainer>
              <Wrapper>
                {reservationData?.is_blocking ? (
                  <MediumTextBold data-cy="btn-cancel-block">Cancelar Bloqueio</MediumTextBold>
                ) : (
                  <MediumTextBold data-cy="btn-cancel-reservation">Cancelar Reserva</MediumTextBold>
                )}
              </Wrapper>
            </TitleContainer>
            <Space />
            <TextField
              dataCy="block-reason"
              label="Descreva o motivo do cancelamento"
              id="notes"
              formik={formik}
              type="textarea"
            />
          </FadeAnimation>
          <ButtonsContainer>
            <FormButton
              data-cy="btn-back"
              type="button"
              onClick={() => onClose(false)}
              variant="outlined"
            >
              Voltar
            </FormButton>
            {reservationData?.is_blocking ? (
              <FormButton data-cy="btn-cancel-block" type="submit">
                Cancelar bloqueio
              </FormButton>
            ) : (
              <FormButton data-cy="btn-cancel-reservation" type="submit">
                Cancelar reserva
              </FormButton>
            )}
          </ButtonsContainer>
        </FormContent>
      </FormContainer>
    </Container>
  );
};

export default CancellReservation;
